import { Component } from "@angular/core";
import { SharedService } from "src/app/services/shared.service";
import { copyText } from "src/app/services/clipboard.util";

@Component({
  selector: "app-icon-gallery",
  templateUrl: "./icon-gallery.component.html",
  styleUrls: ["./icon-gallery.component.scss"],
  standalone: false,
})
export class IconGalleryComponent {
  iconList = [
    "help",
    "logout",
    "setting",
    "user",
    "users",
    "home",
    "feedback-resolved",
    "feedback-un-resolved",
    "storyboard",
    "voiceover",
    "check-green",
    "phone",
    // Navigation icons
    "folder",
    "search",
    "search-plus",
    "search-minus",
    "zoom",
    "settings",
    "menu",
    "grid",
    "list",
    "layers",
    // Action icons
    "plus",
    "circle-plus",
    "square-plus",
    "x",
    "check",
    "edit",
    "trash",
    "copy",
    "download",
    "clipboard",
    "print",
    "upload",
    "share",
    "refresh",
    "swap",
    "git-branch",
    "external-link",
    "expand-diagonal",
    "more-horizontal",
    "more-vertical",
    // Media & Video icons
    "play",
    "pause",
    "skip-forward",
    "skip-back",
    "video",
    "film",
    "camera",
    "image",
    "mic",
    "volume",
    // AI & Production icons
    "ai-sparkle",
    "zap",
    "bar-chart",
    "cpu",
    "brain",
    "clapperboard",
    "wand",
    "workflow",
    "timeline",
    // Communication icons
    "message",
    "mail",
    "bell",

    "at-sign",
    // Status & Feedback icons
    "alert-circle",
    "alert-triangle",
    "check-circle",
    "x-circle",
    "info",
    "info-i",
    "loader",
    "loading-processing",
    "eye",
    // Arrows & Chevrons
    "chevron-up",
    "chevron-down",
    "chevron-left",
    "chevron-right",
    "chevrons-right",
    "arrow-up",
    "arrow-down",
    "arrow-left",
    "arrow-right",

    // Crown
    "crown",

    //social media
    "facebook",
    "google",
    "linkedin",

    "bill-and-payment",
    "clock",
    "star",
    "dollar",
    "lighting",
    "book",
    "notebook",
    "file",
    "file-script",
    "file-text-excel",
    "file-text-pdf",
    "file-text-docx",
    "file-text-presentation",
    "link",
    "anchor",
    "pulse",
    "shield",
    "calender",
    "graduation-cap",
    "location",
    "billinfo",
    "invoice",
    "save",
    "dot",
    "empty-circle",
    "point-of-view",
    "edit-square",
    "drag-handle",
    "sliders",
    "send",
    "gallery",
    "shotpreview",
    "object",
    "regenrate",
    "hexagon",
    "prevbutton",
    "nextbutton",
    "lock",
    "unlock",
    "goto",
    "square",
    "frames-dual",
    "music",
    "thumbs-up",
    // ─── Workspace v2 additions ───
    // 5-stem audio waveform — labels VO + music blocks on the v2 edit timeline.
    "audio-wave",
    // Filled 5-point star — Premium badge variant (outline "star" reads weak at small sizes).
    "star-filled",
    // Quick Create / Frame Builder
    "crop",
    "aperture",
    "palette",
    "wrench",
    "maximize",
    "box",
    "move",
    "cloud",
    "sun",
    "smile",
    "bookmark",
  ];
  searchTerm: string = "";

  constructor(private sharedService: SharedService) { }

  get filteredIcons(): string[] {
    const term = this.searchTerm.toLowerCase().trim();
    if (!term) return this.iconList;
    return this.iconList.filter((icon) => icon.toLowerCase().includes(term));
  }

  copyIcon(iconName: string): void {
    const iconCode = `<app-icon name="${iconName}" size="32" color="#1677ff"></app-icon>`;
    void copyText(iconCode).then((ok) => {
      this.sharedService.messageToastNotification(
        ok ? "success" : "error",
        ok ? "Copied to clipboard!" : "Failed to copy to clipboard",
      );
    });
  }
}
